import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.some.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useStore, useStoreMap } from 'effector-react';
import { equals } from 'ramda';
import * as smApi from '@gmini/sm-api-sdk';
import { useShiftKeyPressed } from '@gmini/utils/lib/useShiftKeyPressed';
import { useSnackbar } from 'notistack';
import { Snackbar } from '@gmini/ui-kit';
import { declensionsOfNum, isNotEmpty } from '@gmini/utils';
import { isNotEmptyGroupType, nodeToApiTypeMap } from "../../../classifier-service/adapters";
import { isUserClassifierGroupNode, isReferenceNode, isReferenceNodeRef, isBimElementNode } from "../../../classifier-service/Node";
import { getNode } from "../../../classifier-service";
import { filterNotExpandedTree } from "../createTree";
import { NodeContainer } from "../NodeContainer/NodeContainer";
import { VirtualizedTree } from "../VirtualizedTree";
import { TreeContextMenu } from "../TreeContextMenu";
import { TreeContextMenuProvider } from "../TreeContextMenu/ctx";
import { buildKeyByPath, createGeneralGroupNode, findFlatChildren, findFlatParents, findInFlatTree, findNextItemIndex, populateDynamicReference, populateReference } from "../utils";
import { Breadcrumbs } from "../Breadcrumbs";
import { DndType } from "../../DragNDrop/dndType";
import { validateMoveFromOwn } from "../../validate/validate-move";
import { validateToRemove } from "../../validate/validate-remove";
import { validateSource } from "../../validate/validate-source";
import { RemoveNodeDialog } from "../multiply/RemoveNodeDialog";
import { isGeneralGroupNode } from "../types";
import { useReadonlyMode } from "../../../hooks";
import { TreeContext } from "../TreeContext";
import { copyFolder, copiedFolder$ } from "../model/copyModel";
import { fetchChildren } from "./fetchChildren";
import { EditorTreeRoot } from "./EditorTree.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var EditorTree = function EditorTree(_ref) {
  var _ctxMenu$item, _ctxMenu$item2, _validateSource, _validateSource2, _validateSource3;

  var nodes$ = _ref.nodes$,
      currentUserClassifier = _ref.currentUserClassifier,
      renderNodeLayout = _ref.renderNodeLayout,
      selectedFromOtherTreeCount = _ref.selectedFromOtherTreeCount,
      setInCreateNode = _ref.setInCreateNode,
      onCancelCreating = _ref.onCancelCreating,
      onSubmitCreating = _ref.onSubmitCreating,
      _onSubmitEditing = _ref.onSubmitEditing,
      onMoveItems = _ref.onMoveItems,
      onPasteGroup = _ref.onPasteGroup,
      onInsertFromOtherTree = _ref.onInsertFromOtherTree,
      validateInsertFromOtherTree = _ref.validateInsertFromOtherTree,
      _onFindAnywhere = _ref.onFindAnywhere,
      onDelete = _ref.onDelete,
      treeModel = _ref.treeModel,
      checkedModel = _ref.checkedModel,
      expandModel = _ref.expandModel,
      onDeleteSelected = _ref.onDeleteSelected,
      searchNodes = _ref.searchNodes,
      onPending = _ref.onPending,
      allowCreate = _ref.allowCreate,
      selectedPath = _ref.selectedPath,
      dynamicMode$ = _ref.dynamicMode$,
      isSpecialNode = _ref.isSpecialNode,
      notify = _ref.notify,
      table = _ref.table,
      dependenciesWithModels$ = _ref.dependenciesWithModels$,
      openedResultCalculating = _ref.openedResultCalculating,
      onCreateIssue = _ref.onCreateIssue,
      onLinkIssue = _ref.onLinkIssue,
      disabledIssue = _ref.disabledIssue,
      onSearchSource = _ref.onSearchSource,
      hideCtxMenu = _ref.hideCtxMenu,
      allowInsertFilteredElements = _ref.allowInsertFilteredElements,
      _onInsertFilteredElements = _ref.onInsertFilteredElements,
      disabledInsertFilteredElements = _ref.disabledInsertFilteredElements,
      isEditingAllowed = _ref.isEditingAllowed,
      searchMatched$ = _ref.searchMatched$,
      dynamicGroupsConditions = _ref.dynamicGroupsConditions,
      fetchExpandedInterceptor = _ref.fetchExpandedInterceptor,
      getAllowCreateFilterTitle = _ref.getAllowCreateFilterTitle,
      getAllowEditFilterTitle = _ref.getAllowEditFilterTitle,
      getAllowRemoveFilterTitle = _ref.getAllowRemoveFilterTitle,
      onCreateFilter = _ref.onCreateFilter,
      onEditFilter = _ref.onEditFilter,
      onRemoveFilter = _ref.onRemoveFilter,
      showRemoveFilter = _ref.showRemoveFilter,
      getAllowRemoveNodeTitle = _ref.getAllowRemoveNodeTitle,
      showCreateFilter = _ref.showCreateFilter,
      showEditFilter = _ref.showEditFilter,
      getAllowRemoveSeveralNodes = _ref.getAllowRemoveSeveralNodes,
      getCountElementsFromSearch = _ref.getCountElementsFromSearch;

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  var shiftKeyPressed = useShiftKeyPressed();

  var _useReadonlyMode = useReadonlyMode(),
      readonlyMode = _useReadonlyMode.readonlyMode;

  var copiedFolderId = useStore(copiedFolder$, {
    loc: {
      file: _effectorFileName,
      line: 234,
      column: 25
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [234, 25]"
  });
  var nodes = useStore(nodes$, {
    loc: {
      file: _effectorFileName,
      line: 235,
      column: 16
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [235, 16]"
  });
  var dynamicMode = useStore(dynamicMode$, {
    loc: {
      file: _effectorFileName,
      line: 236,
      column: 22
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [236, 22]"
  });
  var inCreateNode = useStore(treeModel.inCreateNode$, {
    loc: {
      file: _effectorFileName,
      line: 237,
      column: 23
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [237, 23]"
  });
  var expanded = useStore(expandModel.expanded$, {
    loc: {
      file: _effectorFileName,
      line: 238,
      column: 19
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [238, 19]"
  });
  var checked = useStore(checkedModel.checked$, {
    loc: {
      file: _effectorFileName,
      line: 239,
      column: 18
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [239, 18]"
  });

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      inEditNode = _useState2[0],
      setInEditNode = _useState2[1];

  var _useState3 = useState({
    item: null,
    coords: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      ctxMenu = _useState4[0],
      setCtxMenu = _useState4[1]; // TODO typing


  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      highlightItem = _React$useState2[0],
      setHighlightItem = _React$useState2[1]; // TODO вынести в отдельный хук


  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      deleteDialog = _React$useState4[0],
      setDeleteDialog = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      deleteAllDialog = _React$useState6[0],
      setDeleteAllDialog = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      toDeleteItem = _React$useState8[0],
      setToDeleteItem = _React$useState8[1];

  var ctxMenuNode = useStoreMap({
    store: nodes$,
    keys: [ctxMenu.item],
    fn: function fn(nodes, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          ctxMenuItem = _ref3[0];

      if (!ctxMenuItem) {
        return null;
      }

      var node = getNode(nodes, ctxMenuItem.ref);

      if (!node) {
        return null;
      }

      if (isReferenceNode(node)) {
        return populateReference(nodes, node);
      }

      if (isUserClassifierGroupNode(node)) {
        return createGeneralGroupNode(node);
      }

      if (node.type === 'DynamicBimElementReferenceNode') {
        return populateDynamicReference(nodes, node);
      }

      return node;
    }
  });
  useEffect(function () {
    return expandModel.resetExpanded();
  }, [expandModel]);
  var flatTree = useStore(treeModel.flatTree$, {
    loc: {
      file: _effectorFileName,
      line: 284,
      column: 19
    },
    name: "EditorTree",
    sid: "EditorTree /src/classifier-editor/ClassifierTree/EditorTree/EditorTree.tsx [284, 19]"
  });
  var flatVisibleTree = useMemo(function () {
    return filterNotExpandedTree({
      tree: flatTree,
      expanded: expanded
    });
  }, [expanded, flatTree]);
  var onHighlightItem = React.useCallback(function (item) {
    setHighlightItem(item.path);
    setTimeout(function () {
      return setHighlightItem(null);
    }, 1000);
  }, []);
  var checkedItems = useMemo(function () {
    return flatTree.filter(function (_ref4) {
      var path = _ref4.path;
      return checked[buildKeyByPath(path)];
    }).map(function (_ref5) {
      var ref = _ref5.ref;
      return ref;
    });
  }, [checked, flatTree]);
  var fetchAndOpen = React.useCallback(function (key, node) {
    expandModel.setItemExpanded({
      key: key,
      value: true
    });
    fetchChildren({
      currentClassifierData: currentUserClassifier,
      node: node,
      key: key,
      dynamicMode: dynamicMode
    });
  }, [currentUserClassifier, dynamicMode, expandModel]);
  React.useEffect(function () {
    smApi.UserClassifierPriorityOrder.GetAll.fetch.defaultContext.submit({
      classifierId: currentUserClassifier.id,
      classifierVersion: currentUserClassifier.version
    });
  }, [currentUserClassifier.id, currentUserClassifier.version]);

  var _onDroppedAfter = useCallback(function (_ref6, item) {
    var target = _ref6.target;
    var parent = findInFlatTree(flatTree, item.path.slice(0, -1));
    var nextItemIdx = findNextItemIndex(flatTree, item.path);
    var nextItem = flatTree[nextItemIdx];

    if ((parent === null || parent === void 0 ? void 0 : parent.ref.type) === 'LoadMore' || (parent === null || parent === void 0 ? void 0 : parent.ref.type) === 'CreateNode' || item.ref.type === 'LoadMore' || item.ref.type === 'CreateNode') {
      return;
    }

    var parentId = parent === null || parent === void 0 ? void 0 : parent.ref.id;
    var parentType;

    if (parent) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parentType = nodeToApiTypeMap[parent.ref.type];

      if (isReferenceNodeRef(parent.ref)) {
        var parentNode = getNode(nodes$.getState(), parent.ref);

        var _node = parentNode === null || parentNode === void 0 ? void 0 : parentNode.element;

        parentId = _node === null || _node === void 0 ? void 0 : _node.id; // eslint-disable-next-line @typescript-eslint/no-explicit-any

        parentType = nodeToApiTypeMap[_node === null || _node === void 0 ? void 0 : _node.type];
      }
    }

    var parents = findFlatParents(flatTree, item.path);
    var parentRef = parents.find(function (item) {
      return 'id' in item.ref && isReferenceNodeRef(item.ref);
    });

    if ((parentRef === null || parentRef === void 0 ? void 0 : parentRef.ref.type) === 'LoadMore' || (parentRef === null || parentRef === void 0 ? void 0 : parentRef.ref.type) === 'CreateNode') {
      return;
    }

    var entityType;

    if (target.type === 'UserClassifierGroupNode') {
      entityType = 'UserClassifierGroupWithGroups';
    } else {
      entityType = nodeToApiTypeMap[target.type];
    }

    var params = {
      classifierId: currentUserClassifier.id,
      classifierVersion: currentUserClassifier.version,
      entityId: target.id,
      entityType: entityType,
      parentRefId: parentRef === null || parentRef === void 0 ? void 0 : parentRef.ref.id,
      parentId: parentId,
      parentType: parentType,
      nextEntityId: nextItem !== null && nextItem !== void 0 && nextItem.ref && 'id' in nextItem.ref ? nextItem.ref.id : null
    };
    smApi.UserClassifierPriorityOrder.Recalculate.submit.defaultContext.submit(params);
  }, [currentUserClassifier.id, currentUserClassifier.version, flatTree, nodes$]);

  var _onDroppedBefore = useCallback(function (_ref7, item) {
    var target = _ref7.target;
    var parent = findInFlatTree(flatTree, item.path.slice(0, -1));

    if ((parent === null || parent === void 0 ? void 0 : parent.ref.type) === 'LoadMore' || (parent === null || parent === void 0 ? void 0 : parent.ref.type) === 'CreateNode' || item.ref.type === 'LoadMore' || item.ref.type === 'CreateNode') {
      return;
    }

    var parentId = parent === null || parent === void 0 ? void 0 : parent.ref.id;
    var parentType;

    if (parent) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parentType = nodeToApiTypeMap[parent.ref.type];

      if (isReferenceNodeRef(parent.ref)) {
        var parentNode = getNode(nodes$.getState(), parent.ref);

        var _node2 = parentNode === null || parentNode === void 0 ? void 0 : parentNode.element;

        parentId = _node2 === null || _node2 === void 0 ? void 0 : _node2.id; // eslint-disable-next-line @typescript-eslint/no-explicit-any

        parentType = nodeToApiTypeMap[_node2 === null || _node2 === void 0 ? void 0 : _node2.type];
      }
    }

    var parents = findFlatParents(flatTree, item.path);
    var parentRef = parents.find(function (item) {
      return 'id' in item.ref && isReferenceNodeRef(item.ref);
    });

    if ((parentRef === null || parentRef === void 0 ? void 0 : parentRef.ref.type) === 'LoadMore' || (parentRef === null || parentRef === void 0 ? void 0 : parentRef.ref.type) === 'CreateNode') {
      return;
    }

    var entityType;

    if (target.type === 'UserClassifierGroupNode') {
      entityType = 'UserClassifierGroupWithGroups';
    } else {
      entityType = nodeToApiTypeMap[target.type];
    }

    var params = {
      classifierId: currentUserClassifier.id,
      classifierVersion: currentUserClassifier.version,
      entityId: target.id,
      entityType: entityType,
      parentRefId: parentRef === null || parentRef === void 0 ? void 0 : parentRef.ref.id,
      parentId: parentId,
      parentType: parentType,
      nextEntityId: item.ref.id
    };
    smApi.UserClassifierPriorityOrder.Recalculate.submit.defaultContext.submit(params);
  }, [currentUserClassifier.id, currentUserClassifier.version, flatTree, nodes$]);

  var _canDropToGroup = useCallback(function (_ref8, item) {
    var from = _ref8.from,
        target = _ref8.target;

    if (dynamicMode) {
      return false;
    }

    var targetNode = target ? target : currentUserClassifier;

    if (from === DndType.FROM_OWN_CLASSIFIER) {
      var items = checkedItems.map(function (it) {
        return _objectSpread(_objectSpread({}, it), {}, {
          parentClassifierId: currentUserClassifier.id
        });
      });

      if (!items.length) {
        return false;
      }

      var nestingLevel = item.path.length;

      var _cantMoveTarget = !!validateMoveFromOwn({
        nodes: nodes$.getState(),
        currClsData: currentUserClassifier,
        items: items,
        nestingLevel: nestingLevel,
        targetNode: targetNode,
        dynamicMode: dynamicMode
      });

      return !_cantMoveTarget;
    }

    var cantMoveTarget = !!validateInsertFromOtherTree({
      target: targetNode,
      nestingLevel: item.path.length
    });
    return !cantMoveTarget;
  }, [checkedItems, currentUserClassifier, dynamicMode, nodes$, validateInsertFromOtherTree]);

  var onInsertElementsFromSearch = React.useCallback( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ref, path) {
      var items, _key, _node3;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!((searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter' && searchNodes.nodes.length)) {
                _context.next = 8;
                break;
              }

              items = searchNodes.nodes.filter(function (_ref10) {
                var node = _ref10.node;
                return isBimElementNode(node);
              }).map(function (_ref11) {
                var node = _ref11.node;
                var bimModelReferenceNode = Object.values(nodes.ReferenceNode).find(function (ref) {
                  return ref.element.id === node.modelId && ref.element.type === 'BimModelNode';
                });

                if (!bimModelReferenceNode) {
                  return null;
                }

                return {
                  id: node.id,
                  sourceClassifierId: bimModelReferenceNode.parentClassifierId,
                  sourceClassifierVersion: bimModelReferenceNode.parentClassifierVersion,
                  sourceParentGroupId: bimModelReferenceNode.sourceParentGroupId,
                  type: nodeToApiTypeMap[node.type]
                };
              }).filter(isNotEmpty);
              _context.next = 4;
              return smApi.BimReference.createRefs.defaultContext({
                classifierId: currentUserClassifier.id,
                classifierVersion: currentUserClassifier.version,
                parentGroupId: ref.id,
                items: items
              });

            case 4:
              _key = buildKeyByPath(path);
              _node3 = getNode(nodes, ref);
              fetchAndOpen(_key, createGeneralGroupNode(_node3));
              enqueueSnackbar('', {
                // eslint-disable-next-line react/display-name
                content: function content(key) {
                  return /*#__PURE__*/_jsx(Snackbar, {
                    id: key,
                    message: "\u0412 \u043F\u0430\u043F\u043A\u0443 ".concat(_node3.name, " \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E ").concat(items.length, " ").concat(declensionsOfNum(items.length, ['элемент', 'элемента', 'элементов'])),
                    onClose: function onClose() {
                      return closeSnackbar(key);
                    }
                  });
                },
                variant: 'info'
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref9.apply(this, arguments);
    };
  }(), [closeSnackbar, currentUserClassifier, enqueueSnackbar, fetchAndOpen, nodes, searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.nodes, searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type]);
  var allowInsertElementsFromSearch = React.useCallback(function (ref) {
    var node = getNode(nodes, ref);

    if (!isUserClassifierGroupNode(node) || node.type === 'UserClassifierGroupWithGroupsNode') {
      return false;
    }

    return Boolean((searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter' && searchNodes.nodes.length && !node.filterCondition);
  }, [nodes, searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.nodes.length, searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type]);
  var itemRenderer = useCallback(function (_ref12) {
    var item = _ref12.item;
    var key = buildKeyByPath(item.path);
    var isExpanded = expanded[key];
    var isChecked = !!checked[key];
    var parents = findFlatParents(flatTree, item.path);
    var someParentChecked = parents.some(function (item) {
      return !!checked[buildKeyByPath(item.path)];
    });
    var children = findFlatChildren(flatTree, item.path);
    var someChildChecked = children.some(function (item) {
      return !!checked[buildKeyByPath(item.path)];
    });
    return /*#__PURE__*/_jsx(NodeContainer // key={key}
    , {
      item: item,
      dynamicMode: dynamicMode,
      isExpanded: isExpanded,
      inEdit: equals(item.path, inEditNode === null || inEditNode === void 0 ? void 0 : inEditNode.path),
      nodes$: nodes$,
      renderNodeLayout: renderNodeLayout,
      checkbox: {
        checked: isChecked || someParentChecked,
        indeterminate: someChildChecked,
        disabled: someParentChecked
      },
      toggle: function toggle(n) {
        var nextExpanded = !isExpanded;
        expandModel.setItemExpanded({
          key: key,
          value: nextExpanded
        });

        if (nextExpanded) {
          if (fetchExpandedInterceptor) {
            fetchExpandedInterceptor({
              node: n,
              treeItem: item
            }).then(function () {
              var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                byNodeIds: undefined
              },
                  byNodeIds = _ref13.byNodeIds;

              fetchChildren({
                node: n,
                currentClassifierData: currentUserClassifier,
                key: buildKeyByPath(item.path),
                dynamicMode: dynamicMode,
                byNodeIds: byNodeIds
              });
            });
          } else {
            fetchChildren({
              node: n,
              currentClassifierData: currentUserClassifier,
              key: buildKeyByPath(item.path),
              dynamicMode: dynamicMode
            });
          }
        }
      },
      onLoadMore: function onLoadMore(n, offset, key) {
        return fetchChildren({
          node: n,
          currentClassifierData: currentUserClassifier,
          offset: offset,
          dynamicMode: dynamicMode,
          key: key
        });
      },
      onChecked: function onChecked(value) {
        // !!!!! Если изменится структура дерева - нужно полностью сбросить выделение, т.к. будет неконсистентность в состоянии
        checkedModel.onChecked({
          children: children,
          flatTree: flatVisibleTree,
          key: key,
          value: value,
          shiftKeyPressed: shiftKeyPressed
        });
      },
      onDroppedToGroup: function onDroppedToGroup(_ref14) {
        var from = _ref14.from,
            target = _ref14.target;

        if (target) {
          fetchAndOpen(key, target);
        }

        var targetNode = target ? target : currentUserClassifier;

        if (from === DndType.FROM_OWN_CLASSIFIER) {
          var items = checkedItems.map(function (it) {
            return _objectSpread(_objectSpread({}, it), {}, {
              parentClassifierId: currentUserClassifier.id
            });
          });
          var nestingLevel = item.path.length;
          var result = validateMoveFromOwn({
            nodes: nodes$.getState(),
            currClsData: currentUserClassifier,
            items: items,
            nestingLevel: nestingLevel,
            targetNode: targetNode,
            dynamicMode: dynamicMode
          });

          if (result) {
            notify(result);
            return;
          }

          onMoveItems({
            target: targetNode,
            items: checkedItems
          });
        } else {
          var _result = validateInsertFromOtherTree({
            target: targetNode,
            nestingLevel: item.path.length
          });

          if (_result) {
            notify(_result);
            return;
          }

          onInsertFromOtherTree({
            target: targetNode
          });
        }
      },
      canDropToGroup: function canDropToGroup(props) {
        return _canDropToGroup(props, item);
      },
      onDroppedAfter: function onDroppedAfter(props) {
        return _onDroppedAfter(props, item);
      },
      onDroppedBefore: function onDroppedBefore(props) {
        return _onDroppedBefore(props, item);
      },
      canDropAfter: function canDropAfter(_ref15) {
        var target = _ref15.target;
        return true;
      },
      canDropBefore: function canDropBefore(_ref16) {
        var target = _ref16.target;
        return true;
      },
      onSubmitCreating: onSubmitCreating,
      onCancelCreating: onCancelCreating,
      currentEntity: currentUserClassifier,
      onSubmitEditing: function onSubmitEditing(newName, node) {
        _onSubmitEditing(newName, node); // TODO поднять в родительский компонент, сбрасывать только после успешного сохранения


        setInEditNode(null);
      },
      onCancelEditing: function onCancelEditing() {
        return setInEditNode(null);
      },
      searchNodes: searchNodes,
      onPending: onPending,
      selectedPath: selectedPath,
      isSpecialNode: isSpecialNode(item),
      highlightItem: highlightItem,
      dependenciesWithModels$: dependenciesWithModels$,
      onSearchSource: onSearchSource,
      searchMatched$: searchMatched$
    });
  }, [expanded, checked, flatTree, dynamicMode, inEditNode === null || inEditNode === void 0 ? void 0 : inEditNode.path, nodes$, renderNodeLayout, _canDropToGroup, _onDroppedAfter, _onDroppedBefore, onSubmitCreating, onCancelCreating, searchNodes, onPending, selectedPath, isSpecialNode, highlightItem, dependenciesWithModels$, onSearchSource, searchMatched$, expandModel, fetchExpandedInterceptor, currentUserClassifier, checkedModel, flatVisibleTree, shiftKeyPressed, fetchAndOpen, checkedItems, onMoveItems, notify, validateInsertFromOtherTree, onInsertFromOtherTree, _onSubmitEditing]);
  var breadcrumbsRenderer = useCallback(function (_ref17) {
    var breadCrumbData = _ref17.breadCrumbData,
        scrollTo = _ref17.scrollTo;
    return /*#__PURE__*/_jsx(Breadcrumbs, {
      nodes$: nodes$,
      breadCrumbData: breadCrumbData,
      scrollTo: scrollTo
    });
  }, [nodes$]);
  var validateRemove = useStoreMap({
    store: nodes$,
    keys: [checkedItems],
    fn: function fn(nodes, _ref18) {
      var _ref19 = _slicedToArray(_ref18, 1),
          checkedItems = _ref19[0];

      return validateToRemove({
        items: checkedItems,
        nodes: nodes
      });
    }
  });
  var handleRemoveGroup = React.useCallback(function (ref, name) {
    if (isNotEmptyGroupType(ref.type)) {
      setToDeleteItem({
        ref: ref,
        name: name
      });
      setDeleteDialog(true);
      return;
    }

    onDelete(ref);
  }, [onDelete]);
  var disabledFindAnyWhereTitle = React.useCallback(function (node) {
    var _node$source;

    var notSupportedNode = node.type === 'DynamicBaseGroupNode' || node.type === 'DynamicGeneratedGroupNode' && !node.source || node.type === 'DynamicGeneratedGroupNode' && ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.type) === 'UserClassifierGroup';
    return notSupportedNode ? 'Поиск папок не поддерживается' : null;
  }, []);
  useEffect(function () {
    return function () {
      return checkedModel.resetChecked();
    };
  }, [checkedModel]);
  var onDeleteAll = React.useCallback(function () {
    if (validateRemove.toDeleteGroups.length) {
      setDeleteAllDialog(true);
      return;
    }

    onDeleteSelected(validateRemove.toDeleteAllItems);
  }, [onDeleteSelected, validateRemove.toDeleteAllItems, validateRemove.toDeleteGroups]);
  var onContextMenu = React.useCallback(function (e) {
    e.preventDefault();
    setCtxMenu({
      item: {
        ref: currentUserClassifier,
        path: []
      },
      coords: {
        x: e.clientX,
        y: e.clientY
      }
    });
  }, [currentUserClassifier]);
  var onCopyGroup = React.useCallback(function (ref) {
    var node = nodes.UserClassifierGroupNode[ref.id];

    if (node) {
      copyFolder(node.id);
    }

    enqueueSnackbar('', {
      // eslint-disable-next-line react/display-name
      content: function content(key) {
        return /*#__PURE__*/_jsx(Snackbar, {
          id: key,
          message: "\u041F\u0430\u043F\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430.",
          onClose: function onClose() {
            return closeSnackbar(key);
          }
        });
      },
      variant: 'info'
    });
  }, [closeSnackbar, enqueueSnackbar, nodes.UserClassifierGroupNode]);
  var onPasteGroupHandler = React.useCallback(function () {
    if (copiedFolderId && ctxMenu.item) {
      var parentId = ctxMenu.item.ref.id;

      var _key2 = buildKeyByPath(ctxMenu.item.path);

      onPasteGroup === null || onPasteGroup === void 0 ? void 0 : onPasteGroup({
        parentGroupId: parentId,
        sourceGroupId: copiedFolderId
      });
      expandModel.setItemExpanded({
        key: _key2,
        value: true
      });
    }
  }, [copiedFolderId, ctxMenu.item, expandModel, onPasteGroup]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(TreeContextMenuProvider, {
      value: {
        onOpen: function onOpen(coords, path) {
          var item = findInFlatTree(flatTree, path);

          if (!item) {
            throw new Error('Item not found in flat tree');
          }

          setCtxMenu({
            item: item,
            coords: coords
          });
        },
        path: (_ctxMenu$item = ctxMenu.item) === null || _ctxMenu$item === void 0 ? void 0 : _ctxMenu$item.path,
        hideCtxMenu: hideCtxMenu
      },
      children: [/*#__PURE__*/_jsx(EditorTreeRoot, {
        onContextMenu: onContextMenu,
        children: /*#__PURE__*/_jsx(TreeContext.Provider, {
          value: {
            tree: flatTree,
            dynamicGroupsConditions: dynamicGroupsConditions,
            nodes: nodes
          },
          children: /*#__PURE__*/_jsx(VirtualizedTree, {
            table: table,
            rowHeight: function rowHeight(node) {
              return node.path.length === 1 ? 34 : 30;
            },
            flatTree: flatVisibleTree,
            itemRenderer: itemRenderer,
            breadcrumbsRenderer: breadcrumbsRenderer,
            onHighlightItem: onHighlightItem,
            heightSubtitle: openedResultCalculating ? '71px' : '38px',
            inCreateNode: inCreateNode
          })
        })
      }), /*#__PURE__*/_jsx(TreeContextMenu, {
        openState: ctxMenu.coords,
        item: ctxMenu.item,
        onClose: function onClose() {
          return setCtxMenu({
            item: null,
            coords: null
          });
        },
        onCollapseAll: function onCollapseAll() {
          return expandModel.resetExpanded();
        },
        insertCount: selectedFromOtherTreeCount,
        insertDisabledTitle: ctxMenu.item && ctxMenuNode && isGeneralGroupNode(ctxMenuNode) ? validateInsertFromOtherTree({
          target: ctxMenuNode,
          nestingLevel: (_ctxMenu$item2 = ctxMenu.item) === null || _ctxMenu$item2 === void 0 ? void 0 : _ctxMenu$item2.path.length
        }) : null,
        findAnyWhereDisabledTitle: ctxMenuNode && disabledFindAnyWhereTitle(ctxMenuNode),
        moveCount: checkedItems.length,
        isSelfChecked: checkedItems.some(function (ref) {
          var _ctxMenu$item3;

          return equals(ref, (_ctxMenu$item3 = ctxMenu.item) === null || _ctxMenu$item3 === void 0 ? void 0 : _ctxMenu$item3.ref);
        }),
        moveDisabledTitle: ctxMenu.item && ctxMenuNode && (isGeneralGroupNode(ctxMenuNode) || ctxMenuNode.type === 'UserClassifierNode') ? //TODO Выпилить все проверки во врапперы
        validateMoveFromOwn({
          currClsData: currentUserClassifier,
          items: checkedItems.map(function (it) {
            return _objectSpread(_objectSpread({}, it), {}, {
              parentClassifierId: currentUserClassifier.id
            });
          }),
          nestingLevel: ctxMenu.item.path.length,
          nodes: nodes$.getState(),
          targetNode: ctxMenuNode,
          dynamicMode: dynamicMode
        }) : null,
        onCreateGroup: function onCreateGroup() {
          var _ctxMenu$item4;

          setInCreateNode({
            parentNodeRef: ((_ctxMenu$item4 = ctxMenu.item) === null || _ctxMenu$item4 === void 0 ? void 0 : _ctxMenu$item4.ref) || null
          });

          if (ctxMenu.item) {
            var _key3 = buildKeyByPath(ctxMenu.item.path);

            expandModel.setItemExpanded({
              key: _key3,
              value: true
            });
            fetchChildren({
              currentClassifierData: currentUserClassifier,
              node: ctxMenuNode,
              key: _key3,
              dynamicMode: dynamicMode
            });
          }
        },
        allowCreateGroup: !!(ctxMenu.item && allowCreate(ctxMenu.item)) && !(ctxMenu.item && ctxMenu.item.path.length >= 6),
        deleteAllCount: validateRemove.toDeleteAllItems.length,
        onEditGroup: function onEditGroup() {
          var availableEditing = isEditingAllowed === null || isEditingAllowed === void 0 ? void 0 : isEditingAllowed(ctxMenu.item);

          if (typeof availableEditing !== 'undefined' && !availableEditing) {
            return;
          }

          setInEditNode(ctxMenu.item);
        },
        onCopyGroup: onPasteGroup && onCopyGroup,
        onPasteGroup: onPasteGroup && onPasteGroupHandler,
        allowPasteGroup: !copiedFolderId,
        onDelete: function onDelete(ref) {
          handleRemoveGroup(ref, isGeneralGroupNode(ctxMenuNode) && ctxMenuNode.name || '');
        },
        readonlyMode: readonlyMode,
        onInsertElements: function onInsertElements(groupRef) {
          if (ctxMenu.item) {
            var _key4 = buildKeyByPath(ctxMenu.item.path);

            var _node4 = getNode(nodes$.getState(), groupRef);

            onInsertFromOtherTree({
              target: createGeneralGroupNode(_node4)
            });
            fetchAndOpen(_key4, createGeneralGroupNode(_node4));
          }
        },
        onMoveElements: function onMoveElements(groupRef) {
          var node = getNode(nodes$.getState(), groupRef);
          onMoveItems({
            target: createGeneralGroupNode(node),
            items: checkedItems
          });
        },
        onFindAnywhere: function onFindAnywhere(ref) {
          return _onFindAnywhere(ref, ctxMenu.item.path);
        },
        onDeleteSelected: onDeleteAll,
        removeDisabledTitle: validateRemove.disabledTitle,
        onCreateIssue: onCreateIssue,
        onLinkIssue: onLinkIssue,
        disabledIssue: disabledIssue,
        allowInsertFilteredElements: !!(ctxMenu.item && allowInsertFilteredElements !== null && allowInsertFilteredElements !== void 0 && allowInsertFilteredElements(ctxMenu.item)),
        disabledInsertFilteredElements: disabledInsertFilteredElements,
        onInsertFilteredElements: function onInsertFilteredElements(groupRef) {
          if (ctxMenu.item) {
            var _key5 = buildKeyByPath(ctxMenu.item.path);

            var _node5 = getNode(nodes$.getState(), groupRef);

            _onInsertFilteredElements === null || _onInsertFilteredElements === void 0 ? void 0 : _onInsertFilteredElements(groupRef);
            fetchAndOpen(_key5, createGeneralGroupNode(_node5));
          }
        },
        allowRemoveTitle: ctxMenuNode && ((_validateSource = validateSource(ctxMenuNode)) === null || _validateSource === void 0 ? void 0 : _validateSource.validateRemove),
        allowCreateTitle: ctxMenuNode && ((_validateSource2 = validateSource(ctxMenuNode)) === null || _validateSource2 === void 0 ? void 0 : _validateSource2.validateCreate),
        allowRenameTitle: ctxMenuNode && ((_validateSource3 = validateSource(ctxMenuNode)) === null || _validateSource3 === void 0 ? void 0 : _validateSource3.validateRename),
        getAllowCreateFilterTitle: getAllowCreateFilterTitle,
        getAllowEditFilterTitle: getAllowEditFilterTitle,
        getAllowRemoveFilterTitle: getAllowRemoveFilterTitle,
        showRemoveFilter: showRemoveFilter,
        getAllowRemoveNodeTitle: getAllowRemoveNodeTitle,
        showCreateFilter: showCreateFilter,
        showEditFilter: showEditFilter,
        onCreateFilter: onCreateFilter,
        onEditFilter: onEditFilter,
        onRemoveFilter: onRemoveFilter,
        getAllowRemoveSeveralNodes: getAllowRemoveSeveralNodes,
        allowInsertElementsFromSearch: allowInsertElementsFromSearch,
        onInsertElementsFromSearch: onInsertElementsFromSearch,
        getCountElementsFromSearch: getCountElementsFromSearch
      })]
    }), /*#__PURE__*/_jsx(RemoveNodeDialog, {
      onClose: function onClose() {
        return setDeleteDialog(false);
      },
      open: deleteDialog,
      removeDependency: function removeDependency() {
        setDeleteDialog(false);
        onDelete(toDeleteItem.ref);
      },
      name: [(toDeleteItem === null || toDeleteItem === void 0 ? void 0 : toDeleteItem.name) || '']
    }), /*#__PURE__*/_jsx(RemoveNodeDialog, {
      onClose: function onClose() {
        return setDeleteAllDialog(false);
      },
      open: deleteAllDialog,
      removeDependency: function removeDependency() {
        setDeleteAllDialog(false);
        onDeleteSelected(validateRemove.toDeleteAllItems);
      },
      name: validateRemove.toDeleteGroups
    })]
  });
};